import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux"; // useDispatch add kiya
import {
  RadioGroup,
  FormControlLabel,
  Radio,
  MenuItem,
  Select,
  Grid
} from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";
import MDSnackbar from "components/MDSnackbar";
import axios from "axios";

// Components & Redux Actions
import FilterOrg from "../../OrgAmin/components/FilterOrg";
import { clearSelectedOrg, clearResults } from "../../../../../features/OrgAdmin/orgAdminSlice"; // Import kiya

const initialFormState = {
  vehicleNumber: "",
  name: "",
  nickName: "",
  simNumber: "",
  rechargeExpiry: "",
  certificateExpiry: "",
  description: "",
  type: "",
  tags: "",
  journeyStatus: "enable",
  accessAlert: "enable",
};

function VehicleCreation() {
  const [formData, setFormData] = useState(initialFormState);
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch(); // Dispatch initialize kiya

  // Snackbar States
  const [successSB, setSuccessSB] = useState(false);
  const [errorSB, setErrorSB] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const { selectedOrg } = useSelector((state) => state.org);
  const orgId = selectedOrg?.orgInfo?.orgHandle || "";

  const openSuccessSB = () => setSuccessSB(true);
  const closeSuccessSB = () => setSuccessSB(false);
  const openErrorSB = () => setErrorSB(true);
  const closeErrorSB = () => setErrorSB(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {

    const token = localStorage.getItem("token");

    if (!formData.vehicleNumber || !formData.name || !formData.nickName || !formData.type) {
      setErrorMessage("Please fill all the mandatory (*) fields.");
      openErrorSB();
      return;
    }

    setLoading(true);

    try {
      const payload = {
        things: [
          {
            thingId: formData.vehicleNumber,
            name: formData.name,
            nickName: formData.nickName,
            simNumber: formData.simNumber || null,
            rechargeExpiryDate: formData.rechargeExpiry || null,
            documentExpiryDate: formData.certificateExpiry || null,
            description: formData.description || "",
            type: formData.type,
            devices: [null],
            disableJourneys: formData.journeyStatus === "disable",
            disableAccessAlerts: formData.accessAlert === "disable",
            speedLimit: null,
            tags: formData.tags ? formData.tags.split(",").map((t) => t.trim()) : [],
          },
        ],
      };

      await axios.post(
        `https://v3.dhundhoo.com/superAdmin/thing/add/${orgId}`,
        payload,
        {
          headers: {
            "x-dhundhoo-session": token,
            "Content-Type": "application/json",
          },
        }
      );

      openSuccessSB();

      // Submit hone ke baad form aur org dono clear karna hai to yaha bhi daal sakte ho:
      // handleClear(); 
      setFormData(initialFormState);
    } catch (err) {
      setErrorMessage("Failed to create vehicle. Please try again.");
      openErrorSB();
    } finally {
      setLoading(false);
    }
  };

  // --- FIX: Form ke sath Org bhi clear hoga ---
  const handleClear = () => {
    setFormData(initialFormState); // Form ke fields clear karega
    dispatch(clearSelectedOrg());  // Upar se Org ka selection clear karega
    dispatch(clearResults());      // Agar results bhi clear karne hain (optional)
  };

  const radioStyles = {
    color: "#1A73E8",
    "&.Mui-checked": {
      color: "#1A73E8",
    },
  };

  return (
    <MDBox py={3} px={2}>

      <MDBox mb={4} display="flex" justifyContent="center">
        <FilterOrg />
      </MDBox>

      {orgId ? (
        <MDBox
          component="form"
          role="form"
          sx={{ maxWidth: "800px", margin: "0 auto", p: 2 }}
        >
          <MDTypography variant="h5" mb={3}>Create New Vehicle</MDTypography>

          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={3}><MDTypography variant="button" fontWeight="medium">* Vehicle number:</MDTypography></Grid>
            <Grid item xs={12} md={9}>
              <MDInput fullWidth name="vehicleNumber" value={formData.vehicleNumber} onChange={handleChange} placeholder="Add vehicle number" />
            </Grid>

            <Grid item xs={12} md={3}><MDTypography variant="button" fontWeight="medium">* Name:</MDTypography></Grid>
            <Grid item xs={12} md={9}>
              <MDInput fullWidth name="name" value={formData.name} onChange={handleChange} />
            </Grid>

            <Grid item xs={12} md={3}><MDTypography variant="button" fontWeight="medium">* Nickname:</MDTypography></Grid>
            <Grid item xs={12} md={9}>
              <MDInput fullWidth name="nickName" value={formData.nickName} onChange={handleChange} />
            </Grid>

            <Grid item xs={12} md={3}><MDTypography variant="button" fontWeight="regular">Sim Number:</MDTypography></Grid>
            <Grid item xs={12} md={9}>
              <MDInput fullWidth name="simNumber" value={formData.simNumber} onChange={handleChange} placeholder="Enter Sim Number" />
            </Grid>

            <Grid item xs={12} md={3}><MDTypography variant="button" fontWeight="regular">Recharge Expiry:</MDTypography></Grid>
            <Grid item xs={12} md={9}>
              <MDInput type="date" fullWidth name="rechargeExpiry" value={formData.rechargeExpiry} onChange={handleChange} />
            </Grid>

            <Grid item xs={12} md={3}><MDTypography variant="button" fontWeight="regular">Certificate Expiry:</MDTypography></Grid>
            <Grid item xs={12} md={9}>
              <MDInput type="date" fullWidth name="certificateExpiry" value={formData.certificateExpiry} onChange={handleChange} />
            </Grid>

            <Grid item xs={12} md={3}><MDTypography variant="button" fontWeight="regular">Description:</MDTypography></Grid>
            <Grid item xs={12} md={9}>
              <MDInput fullWidth name="description" value={formData.description} onChange={handleChange} />
            </Grid>

            <Grid item xs={12} md={3}><MDTypography variant="button" fontWeight="medium">* Type:</MDTypography></Grid>
            <Grid item xs={12} md={9}>
              <Select fullWidth name="type" value={formData.type} onChange={handleChange} displayEmpty sx={{ height: 45 }}>
                <MenuItem value="" disabled>Select Type</MenuItem>
                <MenuItem value="SHARED_VEHICLE">Shared Vehicle</MenuItem>
                <MenuItem value="PRIVATE_VEHICLE">Private Vehicle</MenuItem>
              </Select>
            </Grid>

            <Grid item xs={12} md={3}><MDTypography variant="button" fontWeight="regular">Tags:</MDTypography></Grid>
            <Grid item xs={12} md={9}>
              <MDInput fullWidth name="tags" value={formData.tags} onChange={handleChange} placeholder="Enter comma separated tags (e.g. tag1, tag2)" />
            </Grid>

            <Grid item xs={12} md={3}><MDTypography variant="button" fontWeight="regular">Journeys Status:</MDTypography></Grid>
            <Grid item xs={12} md={9}>
              <RadioGroup row name="journeyStatus" value={formData.journeyStatus} onChange={handleChange}>
                <FormControlLabel
                  value="enable"
                  control={<Radio sx={radioStyles} checked={formData.journeyStatus === "enable"} />}
                  label="Enable Journeys"
                />
                <FormControlLabel
                  value="disable"
                  control={<Radio sx={radioStyles} checked={formData.journeyStatus === "disable"} />}
                  label="Disable Journeys"
                />
              </RadioGroup>
            </Grid>

            <Grid item xs={12} md={3}><MDTypography variant="button" fontWeight="regular">Access (RFID) Alert:</MDTypography></Grid>
            <Grid item xs={12} md={9}>
              <RadioGroup row name="accessAlert" value={formData.accessAlert} onChange={handleChange}>
                <FormControlLabel
                  value="enable"
                  control={<Radio sx={radioStyles} checked={formData.accessAlert === "enable"} />}
                  label="Enable Access Alerts"
                />
                <FormControlLabel
                  value="disable"
                  control={<Radio sx={radioStyles} checked={formData.accessAlert === "disable"} />}
                  label="Disable Access Alerts"
                />
              </RadioGroup>
            </Grid>
          </Grid>

          <MDBox display="flex" gap={2} mt={4}>
            <MDButton variant="gradient" color="info" onClick={handleSubmit} disabled={loading}>
              {loading ? "Adding..." : "Add thing"}
            </MDButton>
            <MDButton variant="outlined" color="secondary" onClick={handleClear}>
              Clear
            </MDButton>
          </MDBox>

        </MDBox>
      ) : (
        <MDBox display="flex" justifyContent="center" mt={5}>
          <MDTypography variant="h6" color="secondary" opacity={0.7}>
            Please select an organization from the top to create a vehicle.
          </MDTypography>
        </MDBox>
      )}

      {/* --- SNACKBARS --- */}
      <MDSnackbar
        color="success"
        icon="check"
        title="Success"
        content="Vehicle created successfully!"
        dateTime="Just now"
        open={successSB}
        onClose={closeSuccessSB}
        close={closeSuccessSB}
        bgWhite
      />

      <MDSnackbar
        color="error"
        icon="warning"
        title="Error"
        content={errorMessage}
        dateTime="Just now"
        open={errorSB}
        onClose={closeErrorSB}
        close={closeErrorSB}
        bgWhite
      />
    </MDBox>
  );
}

export default VehicleCreation;